import axios from 'axios'
import './studios.css'
import { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner';
import { Link } from 'react-router-dom';

const Studios = () => {

    const [studios, setStudios] = useState([])
    const [loading, setLoading] = useState(true);

     useEffect(() => {
      axios.get("https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/studioBatchTiming")
      .then((res) => {
        console.log("Studios",res?.data?.data)
        const filteredStudios = res?.data?.data.filter(item => item.isActive);
        setStudios(filteredStudios)
        setLoading(false);
      })
      .catch((err) => {
        console.log(err)
        setLoading(false);
      })
    }, [])

    if (loading) {
        return (
          <div className="fp-Container">
            <Loader type="TailSpin" color="#FE5266" height={30} width={30} />
          </div>
        );
    }


  return (
    <div className="QuickReads pb-5">
        <div className="quickReadsParentContainer">
            <div className="breadcrumbcontainer mb-5">
                <div className="breadcrumb-nav1">
                    <span>Studios</span>
                </div>

                <div className='studio-card-list'>
                    {studios.map((studio) => (
                        <div key={studio.id} className="studio-card">
                            <img src={studio?.studioPngImage} alt={studio.studioName} />
                            <h3>{studio?.studioName}</h3>
                            <Link to={`/studio/${studio?.['url-path']}`} ><button>Edit Studio</button></Link>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    </div>
  )
}

export default Studios